module.exports = __webpack_public_path__ + "img/satisfacao.2c3460d9.svg";